var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("Witamy!")]),_c('div',[_vm._v("Użyj menu po lewej do nawigacji.")]),_c('ul',[_c('li',[_vm._v("Notatnik to miejsce na luźne notatki.")]),_c('li',[_vm._v("Kalendarz służy do układania planu dni i tygodni.")]),_c('li',[_vm._v("Listy służą do tematycznego organizowania zadań i notatek.")])])])
}]

export { render, staticRenderFns }